// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"d52abec1","104":"54e16b81","453":"55dfbff4","598":"cc1e7b04","625":"b43bd216","643":"90f272c7","665":"11a36a09"}[chunkId] + ".chunk.js";
};